import { render } from "./BillingForm.vue?vue&type=template&id=196ab386"
import script from "./BillingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/BillingForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "196ab386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('196ab386', __exports__)) {
    api.reload('196ab386', __exports__)
  }
  
  module.hot.accept("./BillingForm.vue?vue&type=template&id=196ab386", () => {
    api.rerender('196ab386', render)
  })

}


export default __exports__